import request from '@/utils/request'

// 查询投诉工单处理分页
export function pageComplaintHandle(query) {
  return request({
    url: '/system/complaint-handle/page',
    method: 'get',
    params: query,
  })
}

// 查询投诉工单处理列表
export function listComplaintHandle(query) {
  return request({
    url: '/system/complaint-handle/list',
    method: 'get',
    params: query,
  })
}

// 查询投诉工单处理详细
export function getComplaintHandle(data) {
  return request({
    url: '/system/complaint-handle/detail',
    method: 'get',
    params: data,
  })
}

// 新增投诉工单处理
export function addComplaintHandle(data) {
  return request({
    url: '/system/complaint-handle/add',
    method: 'post',
    data: data,
  })
}

// 修改投诉工单处理
export function updateComplaintHandle(data) {
  return request({
    url: '/system/complaint-handle/edit',
    method: 'post',
    data: data,
  })
}

// 删除投诉工单处理
export function delComplaintHandle(data) {
  return request({
    url: '/system/complaint-handle/delete',
    method: 'post',
    data: data,
  })
}
